import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { CitasModel } from 'src/app/models/citas/citas.model';


export class VisitasConsultasListModalFormDefinition {
  public readonly formFields: Form<CitasModel>;
  public readonly model: Partial<CitasModel>;

  constructor(type: FormType, model: Partial<CitasModel>, private readonly context: any = {}) {
    this.model = model;
    this.formFields = {
      name: 'visitas-consultas-list-modal',
      header: 'Datos de la visita',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<CitasModel>[] {
    const fields: FormField<CitasModel>[] = [
      this.textField('fecha', 'Fecha', 1, true, 4, InputType.CALENDAR),
      this.textField('hora', 'Hora', 2, Boolean(this.context.showVisitasHora), 4),
      this.textField('duracion', 'Duración', 3, Boolean(this.context.hasVisitasHoraInicioFin), 4),
      this.textField('cultivo_nombre', 'Cultivo', 4, true, 4),
      this.textField('variedad_nombre', 'Variedad', 5, true, 4),
      this.textField('cliente_nombre', this.context.clienteName ?? 'Cliente', 6, Boolean(this.context.hasClients), 4),
      this.textField('finca_nombre', this.context.fincaName ?? 'Finca', 7, true, 4),
      this.textField('visitador_nombre', 'Visitador', 8, true, 4),
      this.textField('estado_arbolado', 'Estado Arbolado', 9, true, 4),
      this.textField('moviendo', 'Moviendo', 10, true, 4),
      this.textField('estado_cosecha', 'Cosecha', 11, true, 4),
      this.textField('tamanyo', 'Tamaño', 12, true, 4),
      this.textField('humedad', 'Humedad', 13, true, 4),
      this.textField('estado_floracion', 'Floración', 14, true, 4),
      this.textField('observaciones', 'Observaciones', 15, Boolean(this.context.showVisitasConsultasObservaciones), 4),
    ];

    for (let index = 1; index <= 4; index++) {
      fields.push(this.textField(`plaga${index}`, `Plaga ${index}`, fields.length + 1, true, 4));
      fields.push(this.textField(`estado_plaga${index}`, `Estado Plaga ${index}`, fields.length + 1, true, 4));
    }

    return [{ name: '', fields, width: 12, isVisible: true, order: 1 }];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<CitasModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
